<template>
  <div class="card">
    <transition name="slide-fade" mode="out-in">
      <div
        :class="
          value_color == null
            ? statusColor(value ? value : 0)
            : colorTaxa(value ? value : 0)
        "
        class="-mb-2 text-center text-xl font-bold"
        :key="value"
      >
        <span v-if="percentage">
          {{
            value
              ? convertDecimal(value, qtd_decimal)
              : value == 0
              ? 0
              : value || "-"
          }}<span v-show="value">{{ initials }}</span></span
        >
        <span v-if="cash">
          <span v-show="value">{{ value | currency }}</span>
          <span v-show="!value"> {{ value == 0 ? 0 : value || "-" }} </span>
        </span>
        <span class="text-ontick-carbon-900 dark:text-gray-300" v-if="num">
          {{ value == 0 ? 0 : value || "-" }}
        </span>
        <span
          :class="
            value > 1
              ? 'text-ontick-green-700 dark:text-ontick-green-500'
              : value == 0 || !value
              ? 'text-ontick-carbon-900 dark:text-gray-300'
              : 'text-ontick-red-700 dark:text-ontick-red-500'
          "
          v-if="fac"
        >
          {{ value ? value.toFixed(2) : value == 0 ? 0 : value || "-" }}
          <span v-show="value">X</span>
        </span>
      </div>
    </transition>

    <dt
      class="truncate py-1 text-xs font-medium text-ontick-steel-500 dark:text-gray-300 xl:text-sm"
    >
      {{ title }}
    </dt>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: undefined,
    },
    initials: {
      type: String,
      default: "%",
    },
    percentage: {
      type: Boolean,
      default: false,
    },
    cash: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Boolean,
      default: false,
    },
    fac: {
      type: Boolean,
      default: false,
    },
    value_color: {
      type: Number,
      default: null,
    },
    qtd_decimal: {
      type: Number,
      default: 2,
    },
  },

  methods: {
    convertDecimal(value, qtd) {
      let new_value;
      new_value = parseFloat(value).toLocaleString("pt-BR", {
        minimumFractionDigits: qtd,
        maximumFractionDigits: qtd,
      });
      return new_value;
    },

    colorTaxa(value) {
      let color;

      if (value >= this.value_color) {
        color = "dark:text-ontick-green-500 text-ontick-green-700";
      } else if (value == 0 || value == "-") {
        color = "dark:text-gray-300 text-ontick-carbon-900";
      } else {
        color = "dark:text-ontick-red-500 text-ontick-red-700";
      }

      return color;
    },

    statusColor(value) {
      let color;
      if (value < 0) {
        color = "dark:text-ontick-red-500 text-ontick-red-700";
      } else if (value == 0 || value == "-") {
        color = "dark:text-gray-300 text-ontick-carbon-900";
      } else {
        color = "dark:text-ontick-green-500 text-ontick-green-700 ";
      }
      return color;
    },
  },
};
</script>

<style></style>
